import { apiFetch } from '@app/utils/utils';
import { AdminBillingSummary, AdminSubscription, AdminCreditLedgerEntry } from '@app/Billing/types';

const BASE = '/api/admin/billing';

export async function getBillingSummary(): Promise<AdminBillingSummary> {
  const res = await apiFetch(`${BASE}/summary`);
  if (!res.ok) throw new Error(`Failed to load billing summary (${res.status})`);
  return res.json();
}

export async function getSubscriptions(opts: {
  status?: string;
  tier?: string;
  limit?: number;
  offset?: number;
} = {}): Promise<AdminSubscription[]> {
  const params = new URLSearchParams();
  if (opts.status) params.set('status', opts.status);
  if (opts.tier) params.set('tier', opts.tier);
  if (opts.limit != null) params.set('limit', String(opts.limit));
  if (opts.offset != null) params.set('offset', String(opts.offset));
  const qs = params.toString();
  const res = await apiFetch(`${BASE}/subscriptions${qs ? `?${qs}` : ''}`);
  if (!res.ok) throw new Error(`Failed to load subscriptions (${res.status})`);
  return res.json();
}

export async function getLedger(limit = 100): Promise<AdminCreditLedgerEntry[]> {
  const res = await apiFetch(`${BASE}/ledger?limit=${limit}`);
  if (!res.ok) throw new Error(`Failed to load credit ledger (${res.status})`);
  return res.json();
}
